import { render, staticRenderFns } from "./ROIcard.vue?vue&type=template&id=75bdfb3e&scoped=true&"
import script from "./ROIcard.vue?vue&type=script&lang=js&"
export * from "./ROIcard.vue?vue&type=script&lang=js&"
import style0 from "./ROIcard.vue?vue&type=style&index=0&id=75bdfb3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bdfb3e",
  null
  
)

export default component.exports